"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _moment = _interopRequireDefault(require("moment"));

var _status = _interopRequireDefault(require("../../../constants/status"));

require("../styles/_header.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getVersionNumber(versionNumber) {
  return "".concat(versionNumber).padStart(2, '0');
}

var FIRST_STAGE = {
  text: 'video brief',
  icon: 'video'
};

var VERSION_STAGE = function VERSION_STAGE(_ref) {
  var versionNumber = _ref.versionNumber,
      submittedAt = _ref.submittedAt;
  return {
    text: "VERSION ".concat(getVersionNumber(versionNumber)),
    minText: "V ".concat(getVersionNumber(versionNumber)),
    subtitle: (0, _moment.default)(Number.isNaN(Number(submittedAt)) ? submittedAt : new Date(parseInt(submittedAt, 10))).format('DD/MM/YYYY')
  };
};

var LAST_STAGE = function LAST_STAGE(_ref2) {
  var statusName = _ref2.statusName,
      latestVersion = _ref2.latestVersion,
      hasInternalPermission = _ref2.hasInternalPermission;
  var displayText = statusName === 'APPROVED' ? 'COMPLETE' : "VERSION ".concat(getVersionNumber(latestVersion));
  return {
    subtitle: displayText,
    minText: displayText,
    text: statusName === 'INTERNAL_REVIEW' && !hasInternalPermission ? _status.default.EDITING : _status.default[statusName]
  };
};

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClickStage", function (index) {
      var _this$props = _this.props,
          gotoOutput = _this$props.gotoOutput,
          getCurrentOutput = _this$props.getCurrentOutput,
          history = _this$props.history;
      var currentOutput = getCurrentOutput();
      var outputId = currentOutput.outputId,
          versions = currentOutput.versions,
          videoId = currentOutput.videoId;
      var selectedStageIndex = index - 1;

      if (selectedStageIndex === 0) {
        return void history.rootPush("/video-tool/builder/".concat(videoId));
      }

      var versionToSelect = versions[selectedStageIndex - 1];

      if (!versionToSelect || !versionToSelect.versionNumber) {
        return;
      }

      gotoOutput(outputId, versionToSelect.versionNumber)();
    });

    _defineProperty(_assertThisInitialized(_this), "getStages", function () {
      var _this$props2 = _this.props,
          getCurrentOutput = _this$props2.getCurrentOutput,
          hasInternalPermission = _this$props2.hasInternalPermission;
      var currentOutput = getCurrentOutput();
      var versions = currentOutput.versions,
          status = currentOutput.status,
          latestVersion = currentOutput.latestVersion;
      return [FIRST_STAGE].concat(_toConsumableArray(versions.slice(0, -1).map(function (_ref3) {
        var submittedAt = _ref3.submittedAt,
            versionNumber = _ref3.versionNumber;
        return VERSION_STAGE({
          versionNumber: versionNumber,
          submittedAt: submittedAt
        });
      })), [LAST_STAGE({
        statusName: status.name,
        latestVersion: latestVersion,
        hasInternalPermission: hasInternalPermission
      })]);
    });

    _defineProperty(_assertThisInitialized(_this), "gotoDashboard", function () {
      var history = _this.props.history;
      history.rootPush('/video-tool');
    });

    return _this;
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          currentVersionNumber = _this$props3.currentVersionNumber,
          getCurrentOutput = _this$props3.getCurrentOutput,
          videoName = _this$props3.videoName,
          videoProjectName = _this$props3.videoProjectName;
      var output = getCurrentOutput();
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "video-review-header"
        }, /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationPageHeader, {
          title: "[".concat(output.readableId, "] ").concat((0, _getVideoOutputName.default)(output, videoName)),
          subtitle: videoProjectName,
          actionBtnText: "Back to dashboard",
          titleIconColor: "white",
          alwaysShowSubtitle: true,
          actionPopupBackgroundColor: "bigFat",
          actionBtnOnClick: this.gotoDashboard,
          darkMode: true
        }), /*#__PURE__*/_react.default.createElement(_uiKit.Stages, {
          stages: this.getStages(),
          hideStageNumbers: true,
          currentStage: currentVersionNumber + 1,
          onClick: this.handleClickStage
        }))
      );
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;